import { ReactElement } from 'react';
import { cn } from '@c2fo/liquidity';
import { CaretRightSolidIcon } from '@c2fo/liquidity/icons';
import { NavigationItem } from '../Navigation';

export interface NavigationItemContentProps {
  item: NavigationItem;
  isActive: boolean;
  hasSubItems: boolean;
  animationClassNames: string;
  iconWrapper?: (icon: ReactElement) => ReactElement;
}

export const NavigationItemContent = ({
  item,
  isActive,
  hasSubItems,
  animationClassNames,
  iconWrapper,
}: NavigationItemContentProps) => (
  <>
    <div
      className={cn(
        'absolute right-2 top-0 h-full w-full rounded-r-full bg-transparent',
        {
          'bg-deepBlue-50': isActive,
        },
        animationClassNames
      )}
    />
    <div
      className={cn(
        'absolute -left-1 top-0 h-full w-1 bg-primary-500',
        {
          'left-0': isActive,
        },
        animationClassNames
      )}
    />
    {item.Icon &&
      (() => {
        const icon = (
          <span className="z-10 shrink-0 grow-0">
            <item.Icon
              className={cn('h-6 w-6 fill-text-secondary [&_path]:fill-text-secondary', {
                'fill-primary-500 [&_path]:fill-primary-500': isActive,
              })}
            />
          </span>
        );
        return iconWrapper ? iconWrapper(icon) : icon;
      })()}
    <span className="z-10 text-left">{item.label}</span>
    {item.endSlot && <div className="z-10 ml-auto mr-2">{item.endSlot}</div>}
    {hasSubItems && (
      <CaretRightSolidIcon
        className={cn('z-10 h-5 shrink-0 grow-0 fill-text-secondary', {
          'ml-2 mr-3': item.endSlot,
          'ml-auto mr-3': !item.endSlot,
        })}
      />
    )}
  </>
);
